import React, { useEffect, useState } from "react";
import axios from "../../axiosinstens";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Section2() {
  const [events, setEvents] = useState([]);
  const [allsettings, setSettings] = useState([]);

  const getEvents = async () => {
    try {
      const response = await axios.get("getSeminar");
      const eventsData = response.data.seminar;

      // Sort by priority and then by start_date & start_time in descending order
      const sortedEvents = eventsData.sort((a, b) => {
        // Priority values: lower number = higher priority
        const getPriority = (planName) => {
          if (planName === "Always on Top") return 1;
          if (planName === "Normal") return 2;
          return 3;
        };

        const priorityA = getPriority(a?.plan_id?.name);
        const priorityB = getPriority(b?.plan_id?.name);

        if (priorityA !== priorityB) {
          return priorityA - priorityB; // sort by priority
        }

        // Convert date and time to comparable datetime objects
        const dateTimeA = new Date(`${a.start_date}`);
        const dateTimeB = new Date(`${b.start_date}`);

        // Descending order by datetime
        return dateTimeA - dateTimeB;
      });

      const limitedEvents = sortedEvents.slice(0, 5); // Limit to top 3
      setEvents(limitedEvents);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getSettings = async () => {
    const response = await axios.get("getSetting");
    setSettings(response.data.settings);
  };

  useEffect(() => {
    getSettings();
    getEvents();
  }, []);

  const navigate = useNavigate();

  return (
    <>
      {allsettings.home_heading && allsettings.home_desc && (
        <section className="about_us">
          <div className="container">
            <div className="aboutpara">
              <h2>{allsettings.home_heading}</h2>
              <p>
                {allsettings.home_desc.split("\n").map((line, index) => (
                  <span key={index}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            </div>
          </div>
        </section>
      )}

      {events?.length > 0 && (
        <>
          <div className="evn">
            <h2>Upcoming Events</h2>
            <hr />
          </div>
          <div className="events">
            {events.map((event, index) => (
              <section key={index} className="event">
                <div className="ourevent">
                  <div
                    className="ourevent_left"
                    onClick={() => navigate(`/eventdetails/${event.event_id}`)}
                  >
                    {event?.plan_id?.name === "Always on Top" && (
                      <div className="ribbon-blank">&nbsp;</div>
                    )}
                    {event?.plan_id?.name === "Featured Event" && (
                      <div className="ribbon">Featured</div>
                    )}
                    {event?.plan_id?.name === "Normal" && (
                      <div className="ribbon-blank">&nbsp;</div>
                    )}
                    {event?.plan_id?.name === "At Will" && (
                      <div className="ribbon-blank">&nbsp;</div>
                    )}
                    <div className="event-details">
                      <div className="container">
                        <div className="row">
                          <div className="col-md-3 col-3">
                            {event.start_date && (
                              <div className="evnt_detl">
                                <h3 style={{ textAlign: "center" }}>
                                  <span>Starts On</span>
                                </h3>
                                <h3 style={{ textAlign: "center" }}>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: event.start_date,
                                    }}
                                  />
                                </h3>
                              </div>
                            )}
                          </div>
                          <div className="col-md-7 col-6">
                            <div className="evnt_det2">
                              <h4 className="ev">{event.name}</h4>
                              {event.event_type === "physical_events" &&
                                event.address && (
                                  <p>{event.address} ( Physical Event )</p>
                                )}
                              {event.event_type === "online_event" && (
                                <p>( Online Event )</p>
                              )}
                              <p>
                                {event.category.name}{" "}
                                {event.subcategory &&
                                  " > " + event.subcategory.name}{" "}
                                {event.subsubcategorie &&
                                  " > " + event.subsubcategorie.name}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-2 col-3">
                            {event?.event_price && (
                              <div className="evnt_detl">
                                <h4>
                                  From: <br />{" "}
                                  {event?.settings?.currency_symbol}
                                  {parseFloat(event?.event_price).toFixed(2)}
                                </h4>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            ))}
          </div>
          <div className="viewall">
            <Link to="/eventslistall" state={{ categorie_id: "all" }}>
              View All Seminars
            </Link>
          </div>
        </>
      )}
    </>
  );
}
export default Section2;
